"use client";
import { Button } from "@components/ui/button";
import { Building2, UsersRound } from "lucide-react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const TypeSelection = () => {
	const pathname = usePathname();
	const router = useRouter();
	const searchParams = useSearchParams();

	const onSelectType = (type: string) => {
		const params = new URLSearchParams(searchParams.toString());
		params.set("type", type);
		const path = pathname + "?" + params.toString();
		router.push(path);
	};

	return (
		<div className="flex w-full max-w-5xl flex-col items-center justify-center gap-6 sm:justify-start">
			<div className="flex w-full flex-col items-center justify-center gap-1">
				<h1 className="text-center text-2xl font-semibold">{`Welcome Aboard`}</h1>
				<p className="text-muted-foreground text-center text-sm">{"Choose a role to get started"}</p>
			</div>
			<div className="flex w-full flex-col items-center justify-center gap-4 md:flex-row">
				<Button
					className="bg-accent text-accent-foreground hover:border-secondary hover:bg-secondary/20 hover:text-secondary focus:border-secondary focus:bg-secondary/20 focus:text-secondary flex h-32 w-72 flex-col items-center justify-center gap-2 shadow-xl hover:border-2 focus:border-2 focus-visible:ring-0 focus-visible:ring-transparent focus-visible:ring-offset-0"
					onClick={() => onSelectType("INDIVIDUAL")}
				>
					<UsersRound size={48} strokeWidth={1} />
					<div className="flex w-full flex-col">
						<h1 className="text-sm font-semibold">{"Individual"}</h1>
						<p className="text-xs">{"(Creators / Learners / Parents)"}</p>
					</div>
				</Button>
				<Button
					className="bg-accent text-accent-foreground hover:border-secondary hover:bg-secondary/20 hover:text-secondary focus:border-secondary focus:bg-secondary/20 focus:text-secondary flex h-32 w-72 flex-col items-center justify-center gap-2 shadow-xl hover:border-2 focus:border-2 focus-visible:ring-0 focus-visible:ring-transparent focus-visible:ring-offset-0"
					onClick={() => onSelectType("ORGANIZATION")}
				>
					<Building2 size={48} strokeWidth={1} />
					<div className="flex w-full flex-col">
						<h1 className="text-sm font-semibold">{"Organization"}</h1>
						<p className="text-xs">{"(Corporates / Schools / Universities)"}</p>
					</div>
				</Button>
			</div>
		</div>
	);
};

export default TypeSelection;
